import styled from "styled-components";

export const StyledContainer = styled.div`
    padding: 16px;
    padding-bottom: 5px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const StyledTopContainer = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
`;

export const InputWrapper = styled.div`
    width: 100%;
    .ant-input::placeholder {
        color: ${(props) => props.theme.shelfValueColor};
    }

    .ant-input-outlined,
    .ant-input-search-button {
        background-color: ${(props) =>
            props.theme.secondaryBackgroundColor} !important;

        border-color: ${(props) => props.theme.secondaryBorderColor} !important;
    }
`;
